import { injectReducer } from '../../store/reducers';

export default store => (
  {
    path: 'profile(/:key)',
    /*  Async getComponent is only invoked when route matches   */
    getComponent(nextState, cb) {
      const Profile = require('./containers/ProfileContainer').default;
      const reducer = require('./modules/profile').default;

      injectReducer(store, { key: 'profile', reducer });
      /*  Return getComponent   */
      cb(null, Profile);
    },
  }
);



// WEBPACK FOOTER //
// src/routes/profile/index.js